import { Routes } from '@angular/router';
import { PaymentComponent } from 'shared/src/components/payment/payment.component';
import { paymentDataGuard } from 'shared/src/guards';
import { PostPaymentFlowComponent } from '../../../shared/src/components/post-payment-flow/post-payment-flow.component';
import { CustomizationComponent } from './components/customization/customization.component';
import { EmailComponent } from './components/email/email.component';
import { FormatInputComponent } from './components/format-input/format-input.component';
import { PaywallComponent } from './components/paywall/paywall.component';
import { PreparationComponent } from './components/preparation/preparation.component';
import { QuizStepComponent } from './components/quiz-step/quiz-step.component';
import { StartComponent } from './components/start/start.component';
import { flowScreenIs } from './flow/flow-routing';
import { emailGuard } from './guards/email.guard';

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'quiz/0',
  },
  {
    path: 'quiz',
    redirectTo: 'quiz/0',
    pathMatch: 'full',
  },
  // Before the flow configs the intro had its own URL; an ad may still link to it.
  {
    path: 'intro',
    redirectTo: 'quiz/0',
  },
  // Every flow screen but login and paywall is quiz/<its index in the flow config>. The first
  // route whose screen type matches renders it; quiz steps and out-of-range indexes fall through
  // to QuizStepComponent, which sends the latter back to the start.
  {
    path: 'quiz/:index',
    canMatch: [flowScreenIs('intro')],
    component: StartComponent,
    data: { animation: 'intro' },
  },
  {
    path: 'quiz/:index',
    canMatch: [flowScreenIs('customization')],
    component: CustomizationComponent,
  },
  {
    path: 'quiz/:index',
    canMatch: [flowScreenIs('formatInput')],
    component: FormatInputComponent,
  },
  {
    path: 'quiz/:index',
    canMatch: [flowScreenIs('ready')],
    component: PreparationComponent,
  },
  {
    path: 'quiz/:index',
    component: QuizStepComponent,
  },
  {
    path: 'paywall',
    canActivate: [emailGuard],
    component: PaywallComponent,
    data: { animation: 'paywall' },
  },
  {
    path: 'checkout',
    canActivate: [emailGuard, paymentDataGuard],
    component: PaymentComponent,
    data: { animation: 'checkout' },
  },
  {
    path: 'payment-result',
    component: PostPaymentFlowComponent,
    data: { animation: 'payment-result', checkoutUrl: '/paywall' },
  },
  {
    path: 'login',
    component: EmailComponent,
    data: { animation: 'login' },
  },
];
